import { Component, input, output } from '@angular/core';

import { QueryShortcut } from '../query-shortcut';
import { UiCoreModule } from '@softline/ui-core';

@Component({
    selector: 'soft-query-page-shortcuts',
    imports: [UiCoreModule],
    templateUrl: './query-page-shortcuts.component.html',
    styleUrl: './query-page-shortcuts.component.css'
})
export class QueryPageShortcutsComponent<T> {
  shortcuts = input<QueryShortcut<T>[]>([]);
  shortcutClick = output<T>()
}
